import { ensureUnits } from "../wcUtil.ts"

export const defaultSpacing = ".5rem"

// Custom element for vertical flex layout
class VerticalFlex extends HTMLElement {
  static get observedAttributes() {
    return ['gap'];
  }

  constructor() {
    super();
    this.style.display = 'flex';
    this.style.flexDirection = 'column';
    this.style.gap = defaultSpacing;
    
    // const slot = document.createElement('slot');
    // container.appendChild(slot);
    // this.shadowRoot?.appendChild(container);
  }

  attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
    if (name === 'gap') {
      // const container = this.shadowRoot.firstElementChild as HTMLElement;
      this.style.gap = ensureUnits(newValue);
    }
  }
}

// Custom element for horizontal flex layout
export class HorizontalFlex extends HTMLElement {
  static get observedAttributes() {
    return ['gap'];
  }

  constructor() {
    super();
    this.style.display = 'flex';
    this.style.flexDirection = 'row';
    this.style.gap = defaultSpacing;
  }

  attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
    if (name === 'gap') {
      this.style.gap = ensureUnits(newValue);
    }
  }
}

// Register custom elements
customElements.define('v-flex', VerticalFlex);
customElements.define('h-flex', HorizontalFlex);
